import Login from "../pages/login/login"
import Register from "../pages/login/register"
import Home from "../pages/home/home"
import MyPoints from "../pages/myPoints/myPoints"
import TransferHistory from "../pages/transferHistory/transferHistory"
import Profile from "../pages/profile/profile"
import ContactUs from "../pages/contactUs/contactUs"
import ShareCodigo from "../pages/qr/shareCodigo"
import EditProfile from "../pages/profile/editProfile"

import ROUTES from "./routesConstants"

const routesDef = [
  {
    path: ROUTES.HOME,
    element: <Home />,
  },
  {
    path: ROUTES.LOGIN,
    element: <Login />,
  },
  {
    path: ROUTES.REGISTER,
    element: <Register />,
  },
  {
    path: ROUTES.REGISTER_CODE,
    element: <Register />,
  },
  {
    path: ROUTES.REDEEM_REWARDS,
    element: <MyPoints />,
  },
  {
    path: ROUTES.TRANSACTION_HISTORY,
    element: <TransferHistory />,
  },
  {
    path: ROUTES.PROFILE,
    element: <Profile />,
  },
  {
    path: ROUTES.EDIT_PROFILE,
    element: <EditProfile />,
  },
  {
    path: ROUTES.CONTACT_US,
    element: <ContactUs />,
  },
  {
    path: ROUTES.SHARE_CODE,
    element: <ShareCodigo />,
  },
]

export { routesDef }
